export default function PageShell({ eyebrow, title, subtitle, children, narrow = false }) {
  return (
    <main className={`mx-auto px-6 lg:px-10 py-12 md:py-16 fade-up ${narrow ? "max-w-5xl" : "max-w-7xl"}`}>
      {eyebrow && <div className="small-caps mb-3" data-testid="page-eyebrow">{eyebrow}</div>}
      {title && (
        <h1 className="text-3xl md:text-4xl lg:text-5xl tracking-tighter leading-none mb-3">
          {title}
        </h1>
      )}
      {subtitle && (
        <p className="text-base text-black/65 max-w-2xl mb-8 leading-relaxed">
          {subtitle}
        </p>
      )}
      {children}
    </main>
  );
}
